import { createSelector } from 'reselect'
import { Page } from 'types/Page'

type State = {
  page: Page
}

export const getPage = (state: State) => state?.page || {}

export const getPageData = createSelector(
  [getPage],
  (page): Record<string, any> => page?.data || {}
)

export const getPageIsReady = createSelector([getPage], (page): boolean => page?.isReady || false)

export const getPageParams = createSelector(
  [getPage],
  (page): Record<string, any> => page?.params || {}
)

export const getPageParamsSection = createSelector(
  [getPageParams],
  (pageParams): string => pageParams.section || ''
)

export const getPagePath = createSelector([getPage], (page): string => page?.path || '')

export const getIsIOSWebview = createSelector(
  [getPageData],
  (pageData): boolean => pageData.iOSWebview || false
)

